import * as THREE from 'three'
import {useGLTF} from '@react-three/drei'
import {useMemo} from 'react'

export function useRoomModels() {
    const {nodes: roomNode} = useGLTF('./models/room_as_one_compressed.glb')
    const {nodes: booksNode} = useGLTF('./models/books_compressed.glb')
    const {nodes: transparentNodes} = useGLTF('./models/transparent.glb')
    const {nodes: figurineNodes, materials: figurineMaterials} = useGLTF('./models/figurines.glb')

    // Create materials
    const transparentBox = useMemo(() => new THREE.MeshBasicMaterial({
        color: 'white',
        transparent: true,
        opacity: 0.35
    }), [])

    const transparentWindow = useMemo(() => new THREE.MeshBasicMaterial({
        color: 'white',
        transparent: true,
        opacity: 0.05
    }), [])

    const computerScreenMaterial = useMemo(() => new THREE.MeshBasicMaterial({
        color: 'black'
    }), [])


    const customFigurineMaterials = useMemo(() => {
        const result = {}
        Object.entries(figurineMaterials).forEach(([name, originalMaterial]) => {
            result[name] = new THREE.MeshBasicMaterial({
                map: originalMaterial.map,
            })
        })
        return result
    }, [figurineMaterials])


    return {
        roomNode,
        booksNode,
        transparentNodes,
        figurineNodes,
        transparentBox,
        transparentWindow,
        customFigurineMaterials,
        computerScreenMaterial,
    }
}

// Preload models outside the component
useGLTF.preload('./models/room_as_one_compressed.glb')
useGLTF.preload('./models/figurines.glb')